import NextHead from 'next/head';
import { SeoComponent } from '@model/content';
import { useI18NextContext } from '@components/hooks';

export const PageSeoContainer = ({ title, description, destination }: SeoComponent) => {
  const t: any = useI18NextContext();

  if (!title && !description) {
    return null;
  }
  return (
    <NextHead>
      <title>{t(title, { destination: destination?.display || '' })}</title>
      <meta name="description" content={t(description, { destination: destination?.display || '' })} />
    </NextHead>
  );
};
